export const ABTestingGroup = {
  GROUP_A: 'group_a',
  GROUP_B: 'group_b',
} as const;

export type ABTestingGroupType = typeof ABTestingGroup[keyof typeof ABTestingGroup];
